var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"wdmota-tower-card",attrs:{"href":("/backend/wdtower/linkto.php?name=" + (_vm.tower.name)),"target":"_blank"}},[_c('img',{staticClass:"cover",attrs:{"src":_vm.tower.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }